import React from "react";
import axios from 'axios';

import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import './SenderDetails.css';
import './SendersList.css';
import './SenderPhotoUpload.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import { store } from "../../redux/store";
import { v4 as uuidv4 } from 'uuid';
import SenderSubDetails from "./SenderSubDetails";
import { setOtpResponse } from "../../redux/misc-data/misc-data.action";
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import { setSenderCustomerId } from './../../redux/misc-data/misc-data.action';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";

const httpClient = axios.create();
class SenderReview extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: '',
			otpNo: '',

			errorMessage: '',
			progress:''

		}
	}


	resendOtp = (event) => {
		event.preventDefault();

		const generateOtprRequestHeader = {
			msgType: "GENERATE_OTP",
			service: "DMT",
			src: "review-sender",
			dst: "review-sender",
			channel: "WHITELABEL",
			requesterId: this.props.clientRequesterId,
			requestId: uuidv4(),
			traceId: uuidv4(),
		}

		const otp = {
			mobile: this.props.addsenderRequest.customer.mobile,
			type: "REGISTER_DMT_CUSTOMER"
		}

		const generateOtpRequest = {
			header: generateOtprRequestHeader,
			otpDetails: otp
		}


		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}



		const otpUrl = "/api/v1/otp/generate";
		httpClient.post(otpUrl, generateOtpRequest, { headers }
		).then((response) => {
			console.log('otp generate and resend' + JSON.stringify(response.data));
			if (response.data.response.msg == 'SUCCESS') {
				store.dispatch(setOtpResponse(response.data));
			} else {
				this.errorMessageCall(response.data.response.displayMsg);
			}
		}).catch(error => {
			this.errorMessageCall(error.message);


		});

	}
	enterOtp = (event) => {
		this.setState({
			otpNo: event.target.value
		})
	}


	addSenderDetails = (event) => {
		event.preventDefault();
		console.log(this.state.otpNo + " " + JSON.stringify(this.props.generateOtpResponse.otpDetails.otp));
		// if(this.state.otpNo==
		// 	this.props.generateOtpResponse.otpDetails.otp){

		this.setState({
			progress:'started'
		})
		var addSenderUrl = this.props.addSenderUrl;
		var addSenderRequest = this.props.addsenderRequest;
		;

		var otpDetails1 = {
			mobile: addSenderRequest.otp.mobile,
			type: addSenderRequest.otp.type,
			refNo: this.props.generateOtpResponse.otpDetails.refNo,
			otp: this.state.otpNo

		}

		const registerSenderRequest = {
			header: addSenderRequest.header,
			customer: addSenderRequest.customer,
			deviceInfo: this.props.deviceInfo,
			otp: otpDetails1
		}
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		console.log('calling add sender');

		httpClient.post('/api/v1/dmt/customer/register', registerSenderRequest, { headers }
		).then((response) => {

			this.setState({
				progress:'completed'
			})
			console.log('register sender response' + JSON.stringify(response.data));
			if (response.data.response.msg == 'SUCCESS') {
				store.dispatch(setSenderCustomerId(response.data.customerId))
			

				var gotosenderDetails=document.getElementById('gotosenderDetails');
				gotosenderDetails.click();
			} else {
				this.errorMessageCall(response.data.response.displayMsg);
			}
		}).catch(error => {
			this.setState({
				progress:'completed'
			})
			this.errorMessageCall(error.message);

		});
	}


	errorMessageCall = (error) => {
		this.setState({
			errorMessage: error
		})
	}


	componentDidMount() {

	}
	componentWillUnmount() {
	}




	render() {
		var mobileNoTosendOtp = '';
		console.log('add sender request:' + JSON.stringify(this.props.addsenderRequest) + ' at ' + this.props.addsenderRequestUrl);

		mobileNoTosendOtp = this.props.addsenderRequest.customer.mobile;
		var middleStringForOtp = '';
		for (let i = 0; i < mobileNoTosendOtp.length; i++) {
			middleStringForOtp = middleStringForOtp + 'x';
		}

		mobileNoTosendOtp = mobileNoTosendOtp.substring(0, 2) + middleStringForOtp;


		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">





							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>Review - Add Sender</h3>
												<div class="headbtn">

													<Link to='/add-sender'>
														<button class="dbbtn" type="button">Back</button>
													</Link>

													<Link to='/sender-details'>
														<button id='gotosenderDetails' hidden={true}></button>
													</Link>

												</div>
											</div>

											<SenderSubDetails />

											<form onSubmit={this.addSenderDetails}>
												<div class="dashform">
													<div class="row">
														<div class="col-12 col-md-4">
															<div class="form-floating">
																<input type="number" class="form-control" id="nmae" placeholder="OTP"
																	onInput={(e) => e.target.value = e.target.value.slice(0, 6)}
																	onChange={this.enterOtp}
																	required />

																<label for="nmae">OTP</label>
																<button class="lbbtn otpbtn" type="button"
																	onClick={this.resendOtp}>Resend</button>
																<p class="otptxt">OTP sent via SMS on sender mobile no. {mobileNoTosendOtp} .</p>
															</div>
														</div>

														<div class="col-12">
															<div class="form-check">
																<input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
																<label class="form-check-label" for="flexCheckChecked">
																	I agree to the <a href="#">terms and conditions</a>
																</label>
															</div>
														</div>

														<div class="col-12">
															<button type="submit" class="btn btn-primary"
															disabled={this.state.progress=='started'?true:false}
															// onClick={this.senderDetails}
															>
																Add Now</button>
														</div>

														{this.state.errorMessage != '' &&
															<div class='valid-error'>
																{this.state.errorMessage}
															</div>}

													</div>
												</div>
											</form>


										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<FooterComponet />
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, addsenderRequest, addsenderRequestUrl,
			generateOtpResponse, agentInfo, token,clientRole,clientRequesterId } }
) => ({
	errorMessage, loginErrorMessage, phone, addsenderRequest, addsenderRequestUrl,
	generateOtpResponse, agentInfo, token,clientRole,clientRequesterId
});

export default connect(mapStateToProps, null)(SenderReview);
